export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_13-EN-ed2cafeb8499b6335ab920e0311e93b2.webp";